import cm from 'classnames';
import styles from './_hover-modal.module.scss';

interface HoverModalProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const HoverModal = ({ className, children, ...rest }: HoverModalProps) => {
  return (
    <div className={cm(styles.HoverModal, className)} {...rest}>
      {children}
    </div>
  );
};

export const HoverModal__popup = ({ children, ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={styles.HoverModal__popup} {...rest}>
      {children}
    </div>
  );
};
